import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ActivityInterface } from '../data';
import { ActivityProvider } from '../providers/activity.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetActivitiesUseCase implements UseCase<Observable<Transaction<ActivityInterface[]>>> {
    constructor(private activityProvider: ActivityProvider) {}

    bind(): Observable<Transaction<ActivityInterface[]>> {
        return this.activityProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (activities) => Transaction.success(cloneDeep(activities)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
